import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { resolveShortLink } from '../api/client';

/**
 * Short-link redirect page — /s/:code
 *
 * Resolves the short code via the API and immediately redirects:
 *  - target_token present → /pay/r/{token}  (our payment request page)
 *  - target_url present   → external URL    (e.g. direct iCredit payment page)
 *  - 404 / error          → shows an inline error instead of silent redirect
 */
export default function ShortLinkRedirect() {
  const { code = '' } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!code) {
      navigate('/', { replace: true });
      return;
    }
    resolveShortLink(code)
      .then((res) => {
        const { target_token, target_url } = res.data;
        if (target_token) {
          navigate(`/pay/r/${target_token}`, { replace: true });
        } else if (target_url) {
          window.location.replace(target_url);
        } else {
          setError(true);
        }
      })
      .catch(() => setError(true));
  }, [code, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center space-y-2">
          <p className="text-lg font-medium text-gray-800">קישור לא בתוקף</p>
          <p className="text-sm text-gray-500">Invalid or expired link</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 text-gray-600">
      מעביר...
    </div>
  );
}
